<template>

<div>
  <el-alert v-if="warningMessage" type="warning" title="Warning" show-icon :description="warningMessage" :closable="false" />

  <h4 v-if="title && !warningMessage">{{title}}</h4>&nbsp;
  <el-button v-if="title && !warningMessage" icon="fa fa-sync" size="mini" type="secondary" circle @click="requestSharingTable" />
  <table class="el-table" v-if="site && !warningMessage">
    <thead>
      <tr>
        <th>#</th>
        <th>Sharer</th>
        <th><span>Sharing %</span></th>
        <th v-if="tax"><span>Amount</span></th>
        <th v-if="tax"><span>{{billData.taxName}}</span></th>
        <th><span>TOTAL</span></th>
        <th><span>Advance</span></th>
        <th><span>Adjustment</span></th>
      </tr>
    </thead>

    <tfoot>
      <tr>
        <td></td>
        <td></td>
        <td align="right"><b>{{formatNumber(sharingTotal, 1)}}%</b></td>
        <td v-if="tax" align="right"><b>{{formatNumber(subTotal)}}</b></td>
        <td v-if="tax" align="right"><b>{{formatNumber(taxTotal)}}</b></td>
        <td align="right"><b>{{formatNumber(total)}}</b></td>
        <td align="right"><b>{{formatNumber(totalAdv)}}</b></td>
        <td align="right"><b>{{formatNumber(totalAdj)}}</b></td>
      </tr>
    </tfoot>

    <tbody>
      <tr v-for="(telco, index) in sharing" :key="sharing.sharerNo">
        <th>{{index+1}}</th>
        <td>{{telco.shortName}} <small class="text-muted hidden-md-and-down">{{telco.telcoSiteId}}</small>
          <span v-if="telco.ownMeter"><b class="text-primary"><i class="fa fa-plug"></i></b></span>
          <span v-if="telco.cabin"><b class="text-info"><i class="fa fa-home"></i></b></span>
          <span v-if="!showRow(telco) && !telco.ownMeter" class="fa-stack">
            <i class="fas fa-calendar-alt fa-stack-1x"></i>
            <i class="fas fa-ban fa-stack-2x" style="color:Tomato;"></i>
          </span>
        </td>

        <td v-if="showRow(telco)" align="right" class="text-warning">{{formatNumber(sharingPercent(index), 1)}}%</td>
        <td v-else></td>

        <td v-if="tax && showRow(telco)" align="right">{{formatNumber(sharingValue(index))}}</td>
        <td v-else></td>

        <td v-if="tax && showRow(telco)" align="right">{{formatNumber(taxValue(index))}}</td>
        <td v-else></td>

        <td v-if="showRow(telco)" align="right"><b>{{formatNumber(totalValue(index))}}</b></td>
        <td v-else></td>

        <td v-if="showRow(telco)" align="right" class="text-primary">{{formatNumber(advanceValue(index))}}</td>
        <td v-else></td>

        <td v-if="showRow(telco)" align="right"><span :class="adjustmentValue(index) < 0 ? 'text-danger' : 'text-success'">{{formatNumber(adjustmentValue(index))}}</span></td>
        <td v-else></td>
      </tr>
    </tbody>
  </table>

</div>

</template>

<script>

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

export default {
  mixins: [DateMixins, NumberMixins, PostMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: Number,
      default: null
    },

    title: {
      type: String,
      default: null
    },

    tax: {
      type: Boolean,
      default: true
    }

  },

  watch: {
    rowData: function (value) {
      this.billData = value
      this.requestSharingTable()
    }
  },

  methods: {
    requestSharingTable () {
      let url = null

      if (this.billData && this.billData.id) {
        url = '/utility/sharing/' + this.billData.id
      } else {
        url = url = '/utility/sharing/new/' + this.billData.site_id +
        '/' + (this.billData.periodFrom
          ? this.formatDateSql(this.billData.periodFrom)
          : (this.billData.date ? this.formatDateSql(this.billData.date) : 'null')) +
          (this.billData.total ? '/' + this.billData.total : '')
      }

      this.fetchData(url, this.setTable, 'Utility Sharing Table')
    },

    setTable (data) {

      if (data) {

        if (data.warning) {
          this.warningMessage = data.warning
        } else {
          this.site = data.site
          this.sharing = data.sharers
        }
      }

    },

    showRow (telco) {
      if (telco) {
        if (this.daysDiff(telco.handover, this.billDate) > 0) {
          return false
        } else {
          return !telco.ownMeter
        }
      } else {
        return false
      }
    },

    sharingPercent (index) {
      return this.sharing[index] ? this.sharing[index].percent : null
    },

    sharingValue (index) {
      return this.sharing[index] ? this.sharing[index].amount : null
    },

    taxValue (index, telco) {

      if (this.tax) {
        return this.sharing[index] ? this.sharing[index].tax : null
      } else {
        return 0
      }

    },

    advanceValue (index, telco) {
      return this.sharing[index] ? this.sharing[index].advance : null

    },

    totalValue (index) {
      return this.sharing[index] ? this.sharing[index].total : null
    },

    adjustmentValue (index) {
      return Number(this.totalValue(index) - this.advanceValue(index))
    },

    sumCol (col) {
      let res = 0

      for (let i = 0; i < this.sharing.length; i++) {
        if (this.showRow(this.sharing[i])) {
          res += Number(this.sharing[i][col])
        }
      }

      return res
    }

  },

  computed: {
    sharingTotal: function () {
      return this.sumCol('percent')
    },

    subTotal: function () {
      return this.sumCol('amount')
    },

    taxTotal: function () {
      return this.sumCol('tax')
    },

    total: function () {
      return this.sumCol('total')
    },

    totalAdv: function () {
      return this.sumCol('advance')
    },

    totalAdj: function () {
      return this.total - this.totalAdv
    }

  },

  data () {
    return {
      warningMessage: null,
      billData: this.rowData,
      billDate: this.rowData.periodFrom ? this.rowData.periodFrom : this.rowData.date,
      utilLabel: this.getUtilLabel(settings, this.siteData),
      taxLabel: settings.taxName,
      site: null,
      sharing: null,
      site_id: this.siteId ? this.siteId : (this.rowData && this.rowData.site_id ? this.rowData.site_id : null)
    }
  },

  mounted () {
    this.requestSharingTable()
  }

}

</script>
